import api from './api';

export const getParks = () => {
  return api.post('/api/Parks/GetParks', {});
};

export const addPark = (parkData) => {
  return api.post('/api/Parks/AddParks', parkData);
};

export const updatePark = (parkData) => {
  return api.post('/api/Parks/UpdateParks', parkData);
};

export const deletePark = (guid) => {
  return api.post('/api/Parks/DeleteParks', { guid });
};
